const getAuthToken = () => {
  return localStorage.getItem("token");
};

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// GET: Fetch machine data
export const fetchMachineData = async () => {
  const token = getAuthToken();
  try {
    const response = await fetch(`${BASE_URL}/machines`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch machines");
    }

    return response.json();
  } catch (error) {
    console.error("Error fetching machine data:", error);
    throw error;
  }
};

// POST: Register SIM
export const registerSIM = async (simData) => {
  const token = getAuthToken();
  try {
    const response = await fetch(`${BASE_URL}/tracker-devices/sims`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(simData),
    });

    if (!response.ok) {
      let errorMessage = "SIM registration failed";
      try {
        const errorData = await response.json();
        if (errorData?.message) errorMessage = errorData.message;
      } catch (_) {}
      throw new Error(errorMessage);
    }

    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      return await response.json();
    } else {
      return {};
    }
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

// GET: Fetch SIMs
export const fetchSIMs = async () => {
  const token = getAuthToken();
  const response = await fetch(`${BASE_URL}/tracker-devices/sims`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  if (!response.ok) throw new Error("Failed to fetch SIMs");
  return response.json();
};

// POST: Register Tracker Device
export const registerDevice = async (deviceData) => {
  const token = getAuthToken();
  try {
    const response = await fetch(`${BASE_URL}/tracker-devices`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(deviceData),
    });

    if (!response.ok) {
      throw new Error("Device registration failed");
    }

    return await response.json();
  } catch (error) {
    console.error("API error:", error);
    throw error;
  }
};

// POST: Register Machine
export const registerMachine = async (machineData) => {
  const token = getAuthToken();
  const response = await fetch(`${BASE_URL}/machines`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(machineData),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || "Machine registration failed");
  }

  return response.json();
};

// GET: Fetch machine types
export const fetchMachineTypes = async () => {
  const token = getAuthToken();
  const res = await fetch(`${BASE_URL}/machine-types`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res.json();
};

// GET: Fetch machine variants
export const fetchMachineVariants = async () => {
  const token = getAuthToken();
  const res = await fetch(`${BASE_URL}/machine-variants`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res.json();
};

// GET: Fetch Tracker Devices
export const fetchTrackerDevices = async () => {
  const token = getAuthToken();
  const res = await fetch(`${BASE_URL}/tracker-devices`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res.json();
};

// GET: Fetch all manufacturers
export const fetchManufacturers = async () => {
  const token = getAuthToken();
  const res = await fetch(`${BASE_URL}/manufacturers`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res.json();
};

// POST: Assign machine to dealer
export const assignMachineToDealer = async (machineId, dealerId) => {
  const token = getAuthToken();

  const response = await fetch(
    `${BASE_URL}/machines/${machineId}/assign-to-dealer`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ dealerId: parseInt(dealerId, 10) }),
    }
  );

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || "Failed to assign machine");
  }

  return await response.json();
};

// POST: Assign machine to customer
export const assignMachineToCustomer = async (machineId, customerId) => {
  const token = getAuthToken();

  const response = await fetch(`${BASE_URL}/machines/assign-to-customer`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      machineId: parseInt(machineId, 10),
      customerId: parseInt(customerId, 10),
    }),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || "Failed to assign machine");
  }

  return await response.json();
};
